module.exports = __webpack_public_path__ + "static/img/shezhi_tixian.ea2ed4e4.png";